<template>
  <div>
    <v-dialog
      v-model="postModel"
      width="700"
      class="rounded-4"
      persistent
      @input="$emit('close')"
    >
      <v-card>
      <v-card-title class="border-bottom">
      <div class="w-full">
        <div class="d-flex justify-space-between align-center">
          <p class="mb-0 font-medium">
            {{ postDetails.title || "Post" }}
          </p>
          <v-btn class="shadow-0" fab x-small @click="$emit('close');
                postModel = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      </v-card-title>

        <v-card-text class="mt-2">
          <!-- <v-container> -->
          <v-row>
            <v-col class="col-4">
              <v-card class="rounded-2 mt-2 mb-2">
                <view-image
                  v-if="
                    postDetails.post_media && postDetails.post_media.length <= 1
                  "
                  :image="
                    postDetails.post_media[0]
                      ? postDetails.post_media[0].media
                      : null
                  "
                  defaultImage="default"
                  :height="200"
                  :width="500"
                ></view-image>

                <ImageSlider
                  v-else
                  :imageList="imageList"
                  :height="200"
                  :width="500"
                ></ImageSlider>
              </v-card>
              <div style="height:40px" class="pt-4">
                <div class="d-flex gap-x-4">
                  <SvgIcon
                      :text="postDetails.likes != null ? postDetails.likes.length : 0 "
                      class="pointer"
                  >
                    <template #icon>
                      <LikeIcon
                          @click="showLikedUsers(postDetails.id)"
                      />
                    </template>
                  </SvgIcon>
                  <SvgIcon
                      :text="postDetails.comments.length"
                      class="pointer"
                  >
                    <template #icon>
                      <CommentIcon
                          @click="showCommentedUsers(postDetails.id)"
                      />
                    </template>
                  </SvgIcon>
                </div>
              </div>
<!--              <v-card tile elevation="0" class="mt-3">-->
<!--                <v-list class="transparent" dense>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Post Title</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.title || "" }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Description</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      {{ postDetails.description || "NA" }}-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Creator</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.user || "" }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Type</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      {{-->
<!--                        (postDetails.is_public == 1 ? "Public" : "Private") ||-->
<!--                          "NA"-->
<!--                      }}-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Post Type</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{-->
<!--                          postDetails.post_type == "E"-->
<!--                            ? "Event"-->
<!--                            : postDetails.post_type == "S"-->
<!--                            ? "Social"-->
<!--                            : postDetails.post_type == "N"-->
<!--                            ? "Normal"-->
<!--                            : postDetails.post_type == "G"-->
<!--                            ? "Games"-->
<!--                            : ""-->
<!--                        }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Booking Type</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.booking_type == "F" ? "Free" : "Hire" }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                </v-list>-->
<!--              </v-card>-->
            </v-col>
            <v-col md="8">
              <h3 class="mt-5 black-text">General Information</h3>
              <div class="d-flex flex-column gap-y-2 mt-4">
                <div class="d-flex justify-space-between">
                  <span class="post-view-title">Post Title</span>
                  <span class="post-view-value text-capitalize">{{ postDetails.title || "-" }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="post-view-title">Post Creator</span>
                  <span class="post-view-value">{{ postDetails.user || "" }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="post-view-title">Type</span>
                  <span class="post-view-value">{{
                      (postDetails.is_public == 1 ? "Public" : "Private") ||
                      "NA"
                    }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="post-view-title">Post Type</span>
                  <span class="post-view-value">{{
                      postDetails.post_type == "E"
                          ? "Event"
                          : postDetails.post_type == "S"
                              ? "Social"
                              : postDetails.post_type == "N"
                                  ? "Normal"
                                  : postDetails.post_type == "G"
                                      ? "Games"
                                      : ""
                    }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="post-view-title">Created At</span>
                  <span class="post-view-value">{{
                      postDetails.created_date
                          ? postDetails.created_date +
                          " " +
                          (postDetails.created_time
                              ? postDetails.created_time
                              : " ")
                          : "NA"
                    }}</span>
                </div>
              </div>
            </v-col>
            <v-col md="12" class="pb-0 pt-0">
              <h3 class="mt-5 mb-2 black-text">Details</h3>
              <v-divider></v-divider>
              <div class="d-flex justify-space-between w-full">
                <div class="div-w25">
                  <p class="details-label">Booking Type</p>
                  <p class="details-value">{{ postDetails.booking_type == "F" ? "Free" : "Hire" }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">Location</p>
                  <p class="details-value">{{ postDetails.location || "NA" }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">Price</p>
                  <p class="details-value">{{ "AED " + postDetails.price || "NA" }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">Payment Type</p>
                  <p class="details-value">{{ postDetails.payment_type == "S" ? "Single" : "Group" }}</p>
                </div>
              </div>
              <div class="d-flex justify-space-between w-full">
                <div class="div-w25">
                  <p class="details-label">Start Date</p>
                  <p class="details-value">{{ postDetails.start_date || "NA" }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">End Date</p>
                  <p class="details-value">{{
                          postDetails.end_date ? postDetails.end_date : "NA"
                        }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">Duration</p>
                  <p class="details-value">{{ postDetails.duration || "NA" }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">Is Shared</p>
                  <p class="details-value">{{
                          postDetails.shared_with_all_followers == 1
                            ? "Yes"
                            : "No"
                        }}</p>
                </div>
              </div>
              <div class="d-flex justify-space-between w-full mb-6">
                <div class="div-w25">
                  <p class="details-label">Minimum Players Count</p>
                  <p class="details-value">{{ postDetails.minimum_players }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">Participant Count</p>
                  <p class="details-value">{{ postDetails.participant_count }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label">Status</p>
                  <p class="details-value">{{ postDetails.status ? postDetails.status : "NA" }}</p>
                </div>
                <div class="div-w25">
                  <p class="details-label"></p>
                  <p class="details-value"></p>
                </div>
              </div>
            </v-col>

            <v-col md="12" class="pt-0">
              <v-divider></v-divider>
              <h3 class="mt-5 mb-2 black-text">Description</h3>
              <div class="d-flex justify-space-between w-full">
                {{ postDetails.description || "NA" }}
              </div>
            </v-col>

<!--            <v-col class="col-6">-->
<!--              <v-card tile elevation="0">-->
<!--                <v-list class="transparent" dense>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Location</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      {{ postDetails.location || "NA" }}-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Price</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      {{ "AED " + postDetails.price || "NA" }}-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Payment Type</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      {{ postDetails.payment_type == "S" ? "Single" : "Group" }}-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Start Date</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.start_date || "NA" }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >End Date</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{-->
<!--                          postDetails.end_date ? postDetails.end_date : "NA"-->
<!--                        }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->

<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Duration</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.duration || "NA" }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->

<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Is shared</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{-->
<!--                          postDetails.shared_with_all_followers == 1-->
<!--                            ? "Yes"-->
<!--                            : "No"-->
<!--                        }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Minimum Players</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.minimum_players }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Participant Count</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.participant_count }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->

<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Status</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{ postDetails.status ? postDetails.status : "NA" }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-subtitle class="text-left"-->
<!--                      >Created at</v-list-item-subtitle-->
<!--                    >-->
<!--                    <v-list-item-title class="font-weight-black text-left">-->
<!--                      <span class="text-capitalize"-->
<!--                        >{{-->
<!--                          postDetails.created_date-->
<!--                            ? postDetails.created_date +-->
<!--                              " " +-->
<!--                              (postDetails.created_time-->
<!--                                ? postDetails.created_time-->
<!--                                : " ")-->
<!--                            : "NA"-->
<!--                        }}-->
<!--                      </span>-->
<!--                    </v-list-item-title>-->
<!--                  </v-list-item>-->
<!--                </v-list>-->
<!--              </v-card>-->
<!--            </v-col>-->
          </v-row>
          <!-- </v-container> -->
        </v-card-text>

<!--        <v-card-actions>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn-->
<!--            color=" darken-1"-->
<!--            class="ma-2 white&#45;&#45;text green-color"-->
<!--            text-->
<!--            @click="-->
<!--              () => {-->
<!--                $emit('close');-->
<!--                postModel = false;-->
<!--              }-->
<!--            "-->
<!--            >Close</v-btn-->
<!--          >-->
<!--        </v-card-actions>-->
      </v-card>
    </v-dialog>
    <liked-users-model
      v-bind="likedUsersModel"
      @close="likedUsersModel.postID = null"
    />
    <commented-users-model
      v-bind="commentedUsersModel"
      @close="commentedUsersModel.postID = null"
    />
  </div>
</template>

<script>
import LikedUsersModel from "./LikedUsersModel";
import CommentedUsersModel from "./CommentedUsersModel";
import ImageSlider from "../../../components/Image/ViewImageSlider.vue";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import LikeIcon from "@/assets/images/misc/like.svg";
import CommentIcon from "@/assets/images/misc/comment.svg";
export default {
  components: {
    SvgIcon,
    LikedUsersModel,
    CommentedUsersModel,
    ImageSlider,
    LikeIcon,
    CommentIcon,
  },
  props: {
    postID: { type: Number, default: null },
    type: { type: String, default: "details" },
  },
  data() {
    return {
      postModel: false,
      postDetails: {},
      image: null,
      menu: false,
      imageList: [],
      post: {},
      valid: false,
      creditList: [],
      page: 1,
      totalPages: 1,
      orderId: null,
      likedUsersModel: { postID: null, type: "details" },
      commentedUsersModel: { postID: null, type: "details" },
    };
  },
  watch: {
    postID(val) {
      if (val != null) {
        this.getpostDetails();
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {},
  computed: {},
  methods: {
    getpostDetails() {
      this.$http
        .get("posts/admin/post-details/" + this.postID)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.postDetails = response.data.data;

            this.imageList = [];
            this.postDetails.post_media.forEach((postMedia) => {
              this.imageList.push(postMedia.media);
            });

            this.postModel = true;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    closeAll() {
      this.postModel = false;
      this.valid = false;
      this.$emit("close");
    },

    showLikedUsers(postId) {
      this.likedUsersModel.postID = parseInt(postId);
      this.likedUsersModel.type = "details";
    },
    showCommentedUsers(postId) {
      this.commentedUsersModel.postID = parseInt(postId);
      this.commentedUsersModel.type = "details";
    },
  },
};
</script>

<style scoped>
.personal-trainer_ic {
  /* background-image: url("../../../assets/images/nav_icon/personal-trainer-grey.png"); */
  padding: 10px;
  background-size: contain;
}

.credit_table table thead tr th {
  background: #066a8c !important;
  color: #fff !important;
}

.post-view-title{
  color: rgb(0 0 0 / 39%);
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}
.post-view-value{
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: black;
}
.div-w25{
  width: 25%;
}

.details-label{
  margin-top:10px;
  margin-bottom:6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  color: #838383;
}


.details-value{
  margin-top:5px;
  margin-bottom:2px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.94px;
  text-align: left;
  color: black;
}
</style>
